import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './components/resources/page-not-found/page-not-found.component';

const routes: Routes = [
  /* { path: "Login", component: LogueoComponent, },
  { path: '', loadChildren: () => import('./components/auth/auth-routing.module').then(m => m.AuthRoutingModule) },*/
  { path: 'auth', loadChildren: () => import('./components/auth/auth-routing.module').then(m => m.AuthRoutingModule) },
  { path: 'configuracion', loadChildren: () => import('./components/configuration/configuration-routing.module').then(m => m.ConfigurationRoutingModule) },
  { path: 'cliente', loadChildren: () => import('./components/customers/customers-routing.module').then(m => m.CustomersRoutingModule) },
  { path: 'gastos', loadChildren: () => import('./components/expenses/expenses-routing.module').then(m => m.ExpensesRoutingModule) },
  { path: 'integracion', loadChildren: () => import('./components/integration/integration-routing.module').then(m => m.IntegrationRoutingModule) },
  { path: 'intro', loadChildren: () => import('./components/intro/intro-routing.module').then(m => m.IntroRoutingModule) },
  { path: 'cotizacion', loadChildren: () => import('./components/quotation/quotation.module').then(m => m.QuotationModule) },
  { path: 'reportes', loadChildren: () => import('./components/reports/reports-routing.module').then(m => m.ReportsRoutingModule) },
  { path: 'venta', loadChildren: () => import('./components/sales/sales-routing.module').then(m => m.SalesRoutingModule) },
  { path: 'sku', loadChildren: () => import('./components/sku/sku-routing.module').then(m => m.SkuRoutingModule) },
  { path: 'cartera', loadChildren: () => import('./components/wallet/wallet-routing.module').then(m => m.WalletRoutingModule) },

  { path: "**", loadChildren: () => import('./components/auth/auth-routing.module').then(m => m.AuthRoutingModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
